import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HorizontalAlignment, VerticalAlignment } from '../modal/modal.component';

@Component({
  selector: 'app-loading-panel',
  templateUrl: 'loading-panel.component.html',
  styleUrls: ['loading-panel.component.scss'],
})
export class LoadingPanelComponent {
  @Input()
  visible = false;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  overlayMask = true;

  @Input()
  container: HTMLElement;

  @Input()
  modalVerticalAlignment: VerticalAlignment = 'center';
  @Input()
  modalHorizontalAlignment: HorizontalAlignment = 'center';

  @Input()
  containerVerticalAlignment: VerticalAlignment = 'center';
  @Input()
  containerHorizontalAlignment: HorizontalAlignment = 'center';

  @Input()
  posX: number;

  @Input()
  posY: number;
}
